export default __webpack_public_path__ + "static/media/2018-BV.d6665435.jpg";